export function bigIntToStringWithDecimals(value: bigint, pow: number): string {
    const decimals = BigInt(10 ** pow);

    const beforeDot = (value / decimals).toString();
    const afterDot = (value % decimals).toString();

    return parseFloat(beforeDot + '.' + '0'.repeat(pow - afterDot.length) + afterDot).toString();
}
